<div class="popover">
  <div *ngIf="popoverHeader" class="popover-header">{{ popoverHeader | translate }}</div>
  <div class="search-container" [ngClass]="{ 'search-container--modal': popoverRenderOptionType === 'MODAL' }">
    <ion-searchbar
      [placeholder]="'multi_select.Search' | translate"
      mode="ios"
      color="light"
      (ionChange)="onSearch($event)"
    ></ion-searchbar>
  </div>

  <!-- Shared template for checkbox item -->
  <ng-template #labelWithCheckbox let-option="option">
    <ion-item>
      <ion-checkbox
        [(ngModel)]="option.isSelected"
        [mode]="popoverRenderOptionType === 'INLINE' ? 'ios' : 'md'"
        [ngClass]="{ modal: popoverRenderOptionType === 'MODAL' }"
        (ngModelChange)="onChange()"
      ></ion-checkbox>
      <ion-label
        class="multi-select__label"
        [ngClass]="{ 'multi-select__label--modal': popoverRenderOptionType === 'MODAL' }"
      >
        <ng-container *ngIf="preTagForDataDisplay; else noPreTag">
          <pre>{{ option.displayName | translate }}</pre>
        </ng-container>
        <ng-template #noPreTag>{{ option.displayName | translate }}</ng-template>
      </ion-label>
    </ion-item>
  </ng-template>

  <ion-grid class="multi-select">
    <div
      class="multi-select__option-container"
      [ngClass]="{
        'multi-select__option-container--modal': popoverRenderOptionType === 'MODAL',
        'multi-select__option-container--height': popoverRenderOptionType === 'MODAL'
      }"
    >
      <ng-container *ngIf="virtualScroll; else normalContentLoad">
        <cdk-virtual-scroll-viewport
          [itemSize]="virtualScroll.itemSize"
          [minBufferPx]="virtualScroll.minBufferPx"
          [maxBufferPx]="virtualScroll.maxBufferPx"
          [ngStyle]="{ 'min-height': popoverRenderOptionType === 'INLINE' ? '300px' : 'undefined' }"
        >
          <ng-container *cdkVirtualFor="let option of filteredPopoverInfo; trackBy: trackByFn">
            <ng-container *ngTemplateOutlet="labelWithCheckbox; context: { option: option }"></ng-container>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </ng-container>

      <ng-template #normalContentLoad>
        <ng-container *ngFor="let option of filteredPopoverInfo">
          <ng-container *ngTemplateOutlet="labelWithCheckbox; context: { option: option }"></ng-container>
        </ng-container>
      </ng-template>
    </div>
  </ion-grid>

  <div *ngIf="popoverRenderOptionType !== 'TABS'">
    <ion-row class="multi-select__button-container">
      <ion-col *ngIf="showClose" size="6" class="multi-select__close">
        <ui-custom-button
          [btnTxt]="'multi_select.Close' | translate"
          [buttonType]="'SECONDARY'"
          (clickEvent)="onClose()"
          [expand]="'block'"
        ></ui-custom-button>
      </ion-col>
      <ion-col>
        <ui-custom-button
          [btnTxt]="(popoverBtnText ? popoverBtnText : 'multi_select.Apply') | translate"
          [buttonType]="'PRIMARY'"
          (clickEvent)="onApply(_popoverInfo)"
          [expand]="'block'"
        ></ui-custom-button>
      </ion-col>
    </ion-row>
  </div>
</div>
